import React from 'react'
import { Tooltip } from 'antd'
import { segmentApi } from '@edulastic/api'
import { IconPDLSparkle } from '@edulastic/icons'
import { GroupAssignButtonContainer, GroupAssignButton } from './styled'

const GroupAndAssignButton = ({
  onClick,
  disabled = false,
  tooltipText = '',
  source = '',
}) => {
  const handleClick = () => {
    if (onClick && !disabled) {
      segmentApi.genericEventTrack('GroupAndAssign:ButtonClick', { source })
      onClick()
    }
  }

  return (
    <Tooltip title={tooltipText} placement="left">
      <GroupAssignButtonContainer>
        <GroupAssignButton
          disabled={disabled}
          onClick={handleClick}
          data-joyride-id="identifyLearningGaps"
        >
          <IconPDLSparkle width={24} height={24} />
          <span>Identify Learning Gaps</span>
        </GroupAssignButton>
      </GroupAssignButtonContainer>
    </Tooltip>
  )
}

export default GroupAndAssignButton
